import { api } from '../api';
import type { AvsValidateRequest, AvsValidateResponse } from '../types';

/* istanbul ignore file */

export const addressVerifyApi = api.injectEndpoints({
  overrideExisting: false,
  endpoints: (builder) => ({
    addressVerify: builder.mutation<AvsValidateResponse, AvsValidateRequest>({
      query: (data) => ({
        url: 'api/avs/',
        method: 'POST',
        body: data,
      }),
    }),
  }),
});
